import React from "react";

const Expandable = React.forwardRef(({
  animate,
  className,
  style,
  children,
  ...rest
}, ref) => {
  const classes = [
    "ta-expandable",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div ref={ref} className={classes} style={style} data-animate={animate ? "true" : undefined} {...rest}>
      <div className="ta-no-overflow">{children}</div>
    </div>
  );
});

export default Expandable;
